var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInfo2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.795 12.22a.14.14 0 0 1 .065.01c.02.008.04.023.054.04.086.113.022.443-.12.975l-1.119 4.583c-.364 1.375-.363 2.279.007 2.762a1.175 1.175 0 0 0 1.001.405c1.08 0 3.594-.983 5.804-3.171l-.555-.734c-.63.537-1.384.91-2.193 1.087a.183.183 0 0 1-.155-.074c-.111-.148-.094-.506.055-1.07l1.284-4.815c.348-1.26.355-2.157.02-2.598a.796.796 0 0 0-.67-.304c-1.208 0-3.95 1.192-6.273 3.117l.486.792a7.396 7.396 0 0 1 2.309-1.006Zm3.693-9.213a2.344 2.344 0 0 0-2.445 2.23 1.746 1.746 0 0 0 .44 1.291 1.878 1.878 0 0 0 1.384.497 2.398 2.398 0 0 0 2.468-2.255 1.694 1.694 0 0 0-1.847-1.763Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  })))));
};
export { SvgInfo2 as ReactComponent };